// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"ec70c695","1582":"ec70c695","3714":"d6a5296f","3821":"37097d43","6237":"d6a5296f","8035":"ec70c695"}[chunkId] + ".chunk.css";
};